<template>
    <div class="modal-dialog" v-if="showModal">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myLargeModalLabel" style="font-size: 14px;">Dar de Baja</h4>
                <button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="form theme-form">
                    <div class="row">
                        <div class="col-sm-12" style="padding: 0px 10px;">
                            <div class="mb-3">
                                <label class="form-label">Fecha de Salida</label>
                                <Datepicker class="datepicker-here form-control digits" v-bind:class="formSubmitted ? errors.final_date ? 'is-invalid' : 'is-valid' : ''" v-model="form.final_date" :enable-time-picker="false" :locale="'es-MX'" :format-locale="es" format="dd/MM/yyyy"></Datepicker>
                                <div class="invalid-feedback" v-if="errors.final_date">{{ errors.final_date }}</div>
                            </div>
                        </div>
                        <div class="col-sm-12" style="padding: 0px 10px;">
                            <div class="mb-3">
                                <label>Observaciones</label>
                                <textarea class="form-control" v-model="form.observations" v-bind:class="formSubmitted ? errors.observations ? 'is-invalid' : 'is-valid' : ''" rows="3" @input="form.observations = form.observations.toUpperCase()"></textarea>
                                <div class="invalid-feedback" v-if="errors.observations">{{ errors.observations }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-danger btn-sm" type="button" style="float: right;" @click="disableEmployeeValidation">Confirmar</button>
            </div>
        </div>
    </div>
</template>
<script>
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { es } from 'date-fns/locale'

import ws from '@/services/employees'

import validations from "@/mixins/validations/employeeValidations";
import modalCleanupMixin from '@/mixins/commen/modalCleanupMixin';

export default {
    name: 'disable_employee_modal',
    mixins: [validations, modalCleanupMixin],
    components: {
        Datepicker
    },
    props: {
        employee: Object,
    },
    data(){
        return{
            showModal: true
        }
    },
    beforeMount: async function() {
        this.setForm(this.employee);
    },
    methods: {
        async disableEmployee(form) {
            form.birthdate = form.birthdate.toLocaleDateString('es-MX');
            form.final_date = form.final_date.toLocaleDateString('es-MX');

            let response = await ws.disableEmployee(form);

            if(response.type == "success"){
                this.$toast.success(response.message);
                
                this.showModal = false;

                this.$emit('refresh', response.data);
            
                this.closeModal();
            }
            else{
                this.$toast.error(response.message);
            }
        },
    }
}
</script>